// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u01wug{margin-left:auto}\n._19pkidpf{margin-top:0}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1tke1osq{min-height:100%}\n._2hwx1wug{margin-right:auto}\n._2lx21bp4{flex-direction:column}\n._4cvr1h6o{align-items:center}\n._4t3i1kxc{height:100vh}\n._otyridpf{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
